// extracted by mini-css-extract-plugin
export default {"tooltip":"No-z","sharingV2":"Oo-z","sharingIconsV2":"Po-z","links":"Qo-z","link":"Ro-z","facebookV2":"So-z","twitterV2":"To-z","pinterestV2":"Uo-z"};